module.exports = __webpack_public_path__ + "assets/img/slat_close4.0dcf25a5.svg";